/**
 * Expand/collapse for product cards on the collection grid. Each card
 * starts collapsed (image + name + price). Clicking the header reveals
 * its bulk-order-form body in place — no navigation, no page reload.
 * Multiple cards can be open at once; opening one doesn't close others,
 * since a church may want to fill in quantities across several products
 * before adding them all.
 */
(function () {
  function init() {
    document.querySelectorAll('[data-expandable-card]').forEach(function (card) {
      var toggle = card.querySelector('[data-toggle-expand]');
      var body = card.querySelector('[data-expand-body]');
      if (!toggle || !body) return;

      toggle.addEventListener('click', function () {
        var willOpen = body.hidden;
        body.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        card.classList.toggle('is-open', willOpen);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
